import { useMemo, useState } from "react";
import { categories, categoryGroups } from "@/mocks/home";

export default function CategorySection() {
  const [group, setGroup] = useState("全部");

  const visible = useMemo(
    () => (group === "全部" ? categories : categories.filter((c) => c.group === group)),
    [group]
  );

  return (
    <section id="categories" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-accent-100 text-accent-800 border border-accent-200">
              <i className="ri-layout-grid-line" />
              栏目概览
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              常见栏目的大致分布与浏览方式
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              平台通常会把内容按类型划分为若干栏目。下表列出常见分类及各自的浏览特点，
              便于你在进入站点后更快找到想看的内容方向。
            </p>
          </div>

          <div className="inline-flex p-1 rounded-full bg-background-100 border border-background-200 self-start">
            {categoryGroups.map((g) => (
              <button
                key={g}
                type="button"
                onClick={() => setGroup(g)}
                aria-pressed={group === g}
                className={`px-4 py-1.5 text-sm font-label rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                  group === g
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {g}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {visible.map((cat) => (
            <article
              key={cat.id}
              className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="px-2.5 py-1 text-xs font-label rounded-full bg-accent-50 text-accent-800 border border-accent-200">
                  {cat.group}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{cat.desc}</p>
              <p className="mt-4 pt-3 border-t border-background-200 text-xs text-foreground-600 flex items-center gap-1.5">
                <i className="ri-information-line text-accent-600" />
                {cat.note}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}